module.exports = __webpack_public_path__ + "img/beneficio2.f7dcb046.svg";